import { useEffect, useState } from 'react';
import { supervisorApi } from '../../api/supervisor.js';

const SCOPES = ['platform', 'project', 'hr', 'finance'];

export default function Tags() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState(null);

  function refresh() { supervisorApi.listTags().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  async function save(t) {
    setError(null);
    try {
      if (t.id) await supervisorApi.updateTag(t.id, t);
      else await supervisorApi.createTag(t);
      setEditing(null); refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Save failed');
    }
  }

  async function remove(id) {
    if (!window.confirm('Delete this tag?')) return;
    try { const r = await supervisorApi.deleteTag(id); if (r?.soft) alert('Tag was archived (still in use).'); refresh(); }
    catch (err) { setError(err.response?.data?.message || 'Delete failed'); }
  }

  return (
    <section>
      <header className="page-header">
        <h1>User Tags</h1>
        <button className="btn primary" onClick={() => setEditing({ name: '', slug: '', color: '#6366f1', scope: 'platform' })}>+ New Tag</button>
      </header>
      {error && <div className="alert error">{error}</div>}

      <div className="card">
        <table className="data-table">
          <thead><tr><th></th><th>Name</th><th>Slug</th><th>Scope</th><th>System?</th><th>Used by</th><th></th></tr></thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.id}>
                <td><span className="tag-swatch" style={{ background: t.color }} /></td>
                <td><strong>{t.name}</strong></td>
                <td><code>{t.slug}</code></td>
                <td><span className="chip">{t.scope}</span></td>
                <td>{t.is_system ? <span className="chip status-active">system</span> : <span className="chip">custom</span>}</td>
                <td className="muted">{t.user_count} users</td>
                <td>
                  <button className="btn ghost small" onClick={() => setEditing({ ...t })}>Edit</button>
                  {!t.is_system && <button className="btn ghost small" onClick={() => remove(t.id)}>Delete</button>}
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="muted">No tags defined.</td></tr>}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="card form-card grid-form">
          <h3 className="full">{editing.id ? 'Edit tag' : 'New tag'}</h3>
          <label>Name<input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} /></label>
          <label>Slug<input value={editing.slug} onChange={(e) => setEditing({ ...editing, slug: e.target.value })} placeholder="lowercase-hyphen" /></label>
          <label>Color<input type="color" value={editing.color} onChange={(e) => setEditing({ ...editing, color: e.target.value })} /></label>
          <label>Scope
            <select value={editing.scope} onChange={(e) => setEditing({ ...editing, scope: e.target.value })}>
              {SCOPES.map((s) => <option key={s}>{s}</option>)}
            </select>
          </label>
          <label className="full">Description<input value={editing.description || ''} onChange={(e) => setEditing({ ...editing, description: e.target.value })} /></label>
          <div className="full actions">
            <button className="btn ghost" onClick={() => setEditing(null)}>Cancel</button>
            <button className="btn primary" onClick={() => save(editing)}>Save</button>
          </div>
        </div>
      )}
    </section>
  );
}
